import RAPIER from '@dimforge/rapier3d-compat';
import type { World } from '@dimforge/rapier3d-compat';

import { FIXED_TIMESTEP, GRAVITY } from '../game/constants';

/**
 * Owns the Rapier simulation.
 *
 * The world runs at a FIXED timestep so that the physics behaves identically on
 * a 60 Hz laptop and a 120 Hz phone. `App` drives it with an accumulator; this
 * class never steps itself.
 *
 * NOTE: `RAPIER.init()` must have been awaited before constructing this. That
 * happens once in `main.ts`.
 */
export class PhysicsWorld {
  readonly world: World;

  constructor() {
    const [gx, gy, gz] = GRAVITY;
    this.world = new RAPIER.World({ x: gx, y: gy, z: gz });
    this.world.timestep = FIXED_TIMESTEP;
  }

  /** Advance the simulation by exactly one fixed timestep. */
  step(): void {
    this.world.step();
  }

  get timestep(): number {
    return this.world.timestep;
  }

  /** Number of rigid bodies currently in the world (used by the debug API). */
  get bodyCount(): number {
    return this.world.bodies.len();
  }

  /** Number of colliders currently in the world (used by the debug API). */
  get colliderCount(): number {
    return this.world.colliders.len();
  }
}
